import { IController } from 'angular';
import * as _ from 'lodash';

angular.module('nv.shared.background-job-ui.background-job-progress').component('nvBackgroundJobProgress', {
  template: `<md-progress-circular
                  ng-if="$ctrl.shape === 'circular'"
                  md-mode="{{ $ctrl.mode }}"
                  value="{{ $ctrl.progress }}"
                  md-diameter="{{ $ctrl.mdDiameter }}"
                  ng-disabled="$ctrl.ngDisabled"></md-progress-circular>
              <md-progress-linear
                  ng-if="$ctrl.shape === 'linear'"
                  md-mode="{{ $ctrl.mode }}"
                  value="{{ $ctrl.progress }}"
                  md-diameter="{{ $ctrl.mdDiameter }}"
                  ng-disabled="$ctrl.ngDisabled"></md-progress-linear>`,
  bindings: {
    backgroundJobPromise: '<',
    job: '<',
    mdDiameter: '<',
    ngDisabled: '<',
    shape: '@',
  },
  controller: class BackgroundJobSpinnerCtrl implements IController {
    static $inject = ['$scope', '$mdDialog'];
    // bindings
    private backgroundJobPromise;
    private job;
    private mdDiameter;
    private ngDisabled;
    private shape;

    // local
    private mode;
    private progress;
    private stopListening;
    private currentBackgroundJobListener;

    constructor(private $scope, private $mdDialog) {}

    $onInit() {
      this.mode = 'indeterminate';
      this.progress = 0;
      this.shape = this.shape || 'circular';

      // All of this code below lets the user change the bound background job, or even set it to null.
      // When the bound background job changes, we stop listening to notifications on the previous one
      // and reset the spinner to its default state.

      this.currentBackgroundJobListener = null;

      this.$scope.$watch('backgroundJobPromise', () => this.listenToBackgroundJob());

      if (this.backgroundJobPromise) this.listenToBackgroundJob();
    }

    setProgress(progress) {
      this.progress = Math.round(progress);
      this.mode = 'determinate';

      if (progress === 100) {
        // end job and force modal to hide when progress is 100
        if (this.job) this.job.resolve();
        this.$mdDialog.hide();
      }
    }

    backgroundJobListener(backgroundJobPromise) {
      backgroundJobPromise.then(
        () => {
          if (this.stopListening) return;
          this.setProgress(100);
        },
        () => {
          // The spinner doesn't change if there was an error.
        },
        status => {
          if (this.stopListening) return;
          if (status && _.isNumber(status.progress)) {
            this.setProgress(status.progress);
          }
        },
      );
    }

    listenToBackgroundJob() {
      if (this.currentBackgroundJobListener) {
        this.currentBackgroundJobListener.stopListening = true;
        this.mode = 'indeterminate';
        this.progress = 0;
      }
      if (this.backgroundJobPromise) {
        this.currentBackgroundJobListener = this.backgroundJobListener(this.backgroundJobPromise);
      }
    }
  },
});
